// extracted by mini-css-extract-plugin
module.exports = {"upload-container":"Upload_upload-container__3hC0v","row":"Upload_row__1sy2L","drop-container":"Upload_drop-container__3vPol"};